import * as React from 'react'

import {
  reportStartSurveyClick,
  reportViewSurveyBanner
} from '../../../common/analytics/surveyBannerAnalytics'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../../../common/utils/localStorageHelpers'
import CloseIcon from '../icons/close'
import GlobeIcon from '../icons/globe'

import * as styles from './searchSurveyBanner.module.css'

interface IProps {
  surveyUrl: string
  surveyText: string
  surveyLink: string
  siteId: string
}

interface IState {
  dismissed: boolean
}

const SurveyLink = ({
  onClick,
  surveyUrl,
  text
}: {
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => any
  surveyUrl: string
  text: string
}) => {
  return (
    <a
      onClick={onClick}
      href={surveyUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.surveyLink}
    >
      {text}
    </a>
  )
}

class SearchSurveyBanner extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { dismissed: this.isDismissed() }
  }

  public componentDidMount() {
    if (!this.state.dismissed) {
      reportViewSurveyBanner(this.gaLabel())
    }
  }

  public render() {
    const { surveyUrl, surveyText, surveyLink } = this.props

    if (this.state.dismissed) {
      return null
    }

    return (
      <div className={styles.root}>
        <div className={styles.themeGreen}>
          <div className={styles.globeIcon} aria-hidden="true">
            <GlobeIcon />
          </div>
          <div className={styles.message}>
            <p className={styles.surveyText}>
              {surveyText}{' '}
              <SurveyLink
                onClick={this.onStartSurvey}
                surveyUrl={surveyUrl}
                text={surveyLink}
              />
            </p>
          </div>
          <span
            aria-label="Dismiss survey"
            role="button"
            onClick={this.onDismiss}
            className={styles.surveyDismissIcon}
          >
            <CloseIcon />
          </span>
        </div>
      </div>
    )
  }

  private localStorageKey() {
    return `${this.props.siteId}-search-survey-banner-visibility`
  }

  private gaLabel() {
    return `${this.props.siteId.toUpperCase()} Search Survey`
  }

  private dismiss() {
    setLocalStorageItem(this.localStorageKey(), 'hidden')
    this.setState({ dismissed: true })
  }

  private isDismissed() {
    return getLocalStorageItem(this.localStorageKey(), 'visible') === 'hidden'
  }

  private onDismiss = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault()
    this.dismiss()
  }

  private onStartSurvey = (event: React.MouseEvent<HTMLAnchorElement>) => {
    reportStartSurveyClick(this.gaLabel())
    this.dismiss()
  }
}

export default SearchSurveyBanner
